<template>
  <div id="app">
    <div class="section nav-bar">

        <div class="main-logo-container">

          <router-link to="/">
            <img src="@/assets/Slumber-Bear-Hori.png" alt="Slumber Bear">
          </router-link>

        </div>

        <div class="menu-container">

        </div>
        

    </div>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
    <div class="section footer">
      <div class="container">
        <div class="column left-column">         
          <div class="content">
            <p class="weight-med light-shade-text">About Slumber Bear</p>
            <p class="light-text disclaimer-body">
              Slumber Bear is aimed to help people find their most ideal sleeping pattern. With the digital world growing, and more people finding themselves with non-typical working hours, they are able to take advantage of Sleeping Cycles that were otherwise not possible.
            </p>
             <p class="light-text disclaimer-body">
               Using various Sleeping Cycles that have been studied and proven to help optmise sleeping habits of individuals, Slumber Bear aims to help people learn about new sleeping patterns, quickly calculate their schedule dependent on their needs, and get started right away without too much planning.
            </p>
          </div>
          <a href="https://twitter.com/_kprkr"></a>
          <p class="disclaimer-body accent-text">Created by <a href="https://twitter.com/_kprkr" target="_blank"><strong>Kieran Parker</strong></a></p>
        </div>

        <div class="column right-column">

          <div class="column inner-column left">
            <p class="weight-med light-shade-text">Sleep Cycles</p>
            <ul>
              <router-link to="/Monophasic-Cycle"><li class="light-text disclaimer-body">Monophasic Cycle</li></router-link>

              <router-link to="/Biphasic-Cycle"><li class="light-text disclaimer-body">Biphasic Cycle</li></router-link>

              <router-link to="/Everyman-Cycle"><li class="light-text disclaimer-body">Everyman Cycle</li></router-link>

              <router-link to="/Dymaxion-Cycle"><li class="light-text disclaimer-body">Dymaxion Cycle</li></router-link>

              <router-link to="/Uberman-Cycle"><li class="light-text disclaimer-body">Uberman Cycle</li></router-link>
            </ul>
          </div>

          <div class="column inner-column right">
            <p class="weight-med light-shade-text">Other Pages</p>
            <ul>
              <router-link to="/Upcoming-Features"><li class="light-text disclaimer-body">Upcoming Features</li></router-link>

              <a href="https://www.paypal.me/slumberbear/2usd" target="_blank"><li class="light-text disclaimer-body">Donate</li></a>

            </ul>
          </div>

        </div>




      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Slumber Bear - Sleep Cycle Schedule',
      // all titles will be injected into this template
      titleTemplate: '%s | Slumber Bear'
    }
  }
</script>

<style lang="scss">
@import "@/styles/global.scss";

.nav-bar {
  position: absolute;
  z-index: 100;
  padding-top: 14px;
  padding-bottom: 10px;
  margin-left: 24px;

  @media only screen and (max-width: $mobile) {
    margin-left: 12px;

  }
}

.nav-bar .main-logo-container {
  height: 50px;
  width: 100%;
}

.nav-bar .main-logo-container img {
  height: 50px;

  @media only screen and (max-width: $tablet) {
    height: 40px;
  }

  @media only screen and (max-width: $mobile) {
    height: 32px;
  }
}

.footer {
  background-color: $dark-shade-3;
  padding: 50px 0px;
}


.footer .container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  @media only screen and (max-width: $tablet) {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -ms-grid-row-align: center;
    align-items: center;
  }
}

.footer .disclaimer-body {
  width: 100%;

  @media only screen and (max-width: $mobile) {
    margin-bottom: 10px;
  }
}

.footer .left-column {
  -webkit-box-flex: 5;
  -ms-flex: 5;
  flex: 2;
  margin-right: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  @media only screen and (max-width: $mobile) {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 90%;
    margin-right: 0px;
    margin-bottom: 30px;
  }
}

.footer .right-column {
  display: flex;
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 1;
  width: 100%;

    @media only screen and (max-width: $tablet) {
    margin-top: 30px;
  }


  @media only screen and (max-width: $mobile) {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 90%;
    margin-top: 0px;
  }
}

.footer .inner-column {
  flex: 1;
}

.footer .inner-column.left {
  margin-right: 20px;
}

.footer li {
  list-style: none;
  margin-bottom: 20px;
  margin-top: 4px;
  @media only screen and (max-width: $tablet) {
    margin-bottom: 10px;
    margin-top: 0px;
  }

  @media only screen and (max-width: $mobile) {
    margin-bottom: 6px !important;
    margin-top: 0px;
  }
}

.footer li:hover {
  color: $accent-colour;
  font-weight: 500;
}

.footer a:hover {
  color: $accent-colour;
  text-decoration: underline;
}

.footer .content p:nth-last-child(1) {
  margin-top: 10px;
}
.footer .content p:nth-last-child(2) {
  margin-top: 6px;
}
</style>
